import { render, staticRenderFns } from "./EditLabelDialog.vue?vue&type=template&id=782aac8d&scoped=true"
import script from "./EditLabelDialog.vue?vue&type=script&lang=js"
export * from "./EditLabelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "782aac8d",
  null
  
)

export default component.exports